"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable object-curly-newline, no-underscore-dangle, max-len, complexity */
var qs = require('qs');

var fetchPonyfill = require('fetch-ponyfill');

var Promise = require('es6-promise');

var EventDispatcher = require('../utils/event-dispatcher');

var helpers = require('../utils/helpers'); // Create query params from parameters and options


function createQueryParams(parameters, options) {
  var apiKey = options.apiKey,
      version = options.version,
      sessionId = options.sessionId,
      clientId = options.clientId,
      userId = options.userId,
      segments = options.segments,
      testCells = options.testCells;
  var queryParams = {
    c: version
  };
  queryParams.key = apiKey;
  queryParams.i = clientId;
  queryParams.s = sessionId; // Pull test cells from options

  if (testCells) {
    Object.keys(testCells).forEach(function (testCellKey) {
      queryParams["ef-".concat(testCellKey)] = testCells[testCellKey];
    });
  } // Pull user segments from options


  if (segments && segments.length) {
    queryParams.us = segments;
  } // Pull user id from options


  if (userId) {
    queryParams.ui = userId;
  }

  if (parameters) {
    var page = parameters.page,
        offset = parameters.offset,
        resultsPerPage = parameters.resultsPerPage,
        filters = parameters.filters,
        sortBy = parameters.sortBy,
        sortOrder = parameters.sortOrder,
        section = parameters.section,
        fmtOptions = parameters.fmtOptions,
        hiddenFields = parameters.hiddenFields,
        hiddenFacets = parameters.hiddenFacets,
        variationsMap = parameters.variationsMap,
        qsParam = parameters.qsParam,
        preFilterExpression = parameters.preFilterExpression; // Pull page from parameters

    if (!helpers.isNil(page)) {
      queryParams.page = page;
    } // Pull offset from parameters


    if (!helpers.isNil(offset)) {
      queryParams.offset = offset;
    } // Pull results per page from parameters


    if (!helpers.isNil(resultsPerPage)) {
      queryParams.num_results_per_page = resultsPerPage;
    }

    if (filters) {
      queryParams.filters = filters;
    } // Pull sort by from parameters


    if (sortBy) {
      queryParams.sort_by = sortBy;
    } // Pull sort order from parameters


    if (sortOrder) {
      queryParams.sort_order = sortOrder;
    } // Pull section from parameters


    if (section) {
      queryParams.section = section;
    } // Pull format options from parameters


    if (fmtOptions) {
      queryParams.fmt_options = fmtOptions;
    } // Pull hidden fields from parameters


    if (hiddenFields) {
      if (queryParams.fmt_options) {
        queryParams.fmt_options.hidden_fields = hiddenFields;
      } else {
        queryParams.fmt_options = {
          hidden_fields: hiddenFields
        };
      }
    } // Pull hidden facets from parameters


    if (hiddenFacets) {
      if (queryParams.fmt_options) {
        queryParams.fmt_options.hidden_facets = hiddenFacets;
      } else {
        queryParams.fmt_options = {
          hidden_facets: hiddenFacets
        };
      }
    } // Pull variations map from parameters


    if (variationsMap) {
      queryParams.variations_map = JSON.stringify(variationsMap);
    } // Pull pre_filter_expression from parameters


    if (preFilterExpression) {
      queryParams.pre_filter_expression = JSON.stringify(preFilterExpression);
    } // pull qs param from parameters


    if (qsParam) {
      queryParams.qs = JSON.stringify(qsParam);
    }
  }

  queryParams._dt = Date.now();
  queryParams = helpers.cleanParams(queryParams);
  return queryParams;
} // Create URL from supplied filter name, value and parameters


function createBrowseUrlFromFilter(filterName, filterValue, parameters, options) {
  var serviceUrl = options.serviceUrl; // Validate filter name is provided

  if (!filterName || typeof filterName !== 'string') {
    throw new Error('filterName is a required parameter of type string');
  } // Validate filter value is provided


  if (!filterValue || typeof filterValue !== 'string') {
    throw new Error('filterValue is a required parameter of type string');
  }

  var queryParams = createQueryParams(parameters, options);
  var queryString = qs.stringify(queryParams, {
    indices: false
  });
  return "".concat(serviceUrl, "/browse/").concat(helpers.encodeURIComponentRFC3986(helpers.trimNonBreakingSpaces(filterName)), "/").concat(helpers.encodeURIComponentRFC3986(helpers.trimNonBreakingSpaces(filterValue)), "?").concat(queryString);
} // Create URL from supplied id's


function createBrowseUrlFromIDs(ids, parameters, options) {
  var serviceUrl = options.serviceUrl; // Validate id's are provided

  if (!ids || !Array.isArray(ids) || !ids.length) {
    throw new Error('ids is a required parameter of type array');
  }

  var queryParams = _objectSpread(_objectSpread({}, createQueryParams(parameters, options)), {}, {
    ids: ids
  });

  var queryString = qs.stringify(queryParams, {
    indices: false
  });
  return "".concat(serviceUrl, "/browse/items?").concat(queryString);
} // Create URL for facets


function createBrowseUrlForFacets(parameters, options) {
  var serviceUrl = options.serviceUrl;

  var queryParams = _objectSpread({}, createQueryParams(parameters, options)); // Endpoint does not accept _dt


  delete queryParams._dt;
  var queryString = qs.stringify(queryParams, {
    indices: false
  });
  return "".concat(serviceUrl, "/browse/facets?").concat(queryString);
} // Create URL from supplied facet name and parameters


function createBrowseUrlForFacetOptions(facetName, parameters, options) {
  var serviceUrl = options.serviceUrl; // Validate facet name is provided

  if (!facetName || typeof facetName !== 'string') {
    throw new Error('facetName is a required parameter of type string');
  }

  var queryParams = _objectSpread({}, createQueryParams(parameters, options));

  queryParams.facet_name = facetName; // Endpoint does not accept _dt

  delete queryParams._dt;
  var queryString = qs.stringify(queryParams, {
    indices: false
  });
  return "".concat(serviceUrl, "/browse/facet_options?").concat(queryString);
}
/**
 * Interface to browse related API calls
 *
 * @module browse
 * @inner
 * @returns {object}
 */


var Browse = /*#__PURE__*/function () {
  function Browse(options) {
    (0, _classCallCheck2["default"])(this, Browse);
    this.options = options || {};
    this.eventDispatcher = new EventDispatcher(options.eventDispatcher);
  }
  /**
   * Retrieve browse results from API
   *
   * @function getBrowseResults
   * @description Retrieve browse results from Constructor.io API
   * @param {string} filterName - Filter name to display results from
   * @param {string} filterValue - Filter value to display results from
   * @param {object} [parameters] - Additional parameters to refine result set
   * @param {number} [parameters.page] - The page number of the results (Can't be used together with offset)
   * @param {number} [parameters.offset] - The number of results to skip from the beginning (Can't be used together with page)
   * @param {number} [parameters.resultsPerPage] - The number of results per page to return
   * @param {object} [parameters.filters] - Key / value mapping (dictionary) of filters used to refine results
   * @param {string} [parameters.sortBy='relevance'] - The sort method for results
   * @param {string} [parameters.sortOrder='descending'] - The sort order for results
   * @param {string} [parameters.section='Products'] - The section name for results
   * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.io/rest_api/browse/queries/ for details
   * @param {object} [parameters.preFilterExpression] - Faceting expression to scope browse results. Please refer to https://docs.constructor.io/rest_api/collections#add-items-dynamically
   * @param {string[]} [parameters.hiddenFields] - Hidden metadata fields to return
   * @param {string[]} [parameters.hiddenFacets] - Hidden facets to return
   * @param {object} [parameters.variationsMap] - The variations map object to aggregate variations. Please refer to https://docs.constructor.io/rest_api/variations_mapping for details
   * @param {object} [parameters.qs] - Parameters listed above can be serialized into a JSON object and parsed through this parameter. Please refer to https://docs.constructor.io/rest_api/browse/queries/
   * @param {object} [networkParameters] - Parameters relevant to the network request
   * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
   * @returns {Promise}
   * @see https://docs.constructor.io/rest_api/browse/results
   * @example
   * constructorio.browse.getBrowseResults('group_id', 't-shirts', {
   *     resultsPerPage: 40,
   *     filters: {
   *         size: 'medium'
   *     },
   * });
   */


  (0, _createClass2["default"])(Browse, [{
    key: "getBrowseResults",
    value: function getBrowseResults(filterName, filterValue, parameters) {
      var _this = this;

      var networkParameters = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var requestUrl;
      var fetch = this.options && this.options.fetch || fetchPonyfill({
        Promise: Promise
      }).fetch;
      var signal;

      if (typeof AbortController === 'function') {
        var controller = new AbortController();
        signal = controller && controller.signal; // Handle network timeout if specified

        helpers.applyNetworkTimeout(this.options, networkParameters, controller);
      }

      try {
        requestUrl = createBrowseUrlFromFilter(filterName, filterValue, parameters, this.options);
      } catch (e) {
        return Promise.reject(e);
      }

      return fetch(requestUrl, {
        signal: signal
      }).then(function (response) {
        if (response.ok) {
          return response.json();
        }

        return helpers.throwHttpErrorFromResponse(new Error(), response);
      }).then(function (json) {
        if (json.response && json.response.results) {
          if (json.result_id) {
            // Append `result_id` to each result item
            json.response.results.forEach(function (result) {
              // eslint-disable-next-line no-param-reassign
              result.result_id = json.result_id;
            });
          }

          _this.eventDispatcher.queue('browse.getBrowseResults.completed', json);

          return json;
        }

        throw new Error('getBrowseResults response data is malformed');
      });
    }
    /**
     * Retrieve browse results from API using item id's
     *
     * @function getBrowseResultsForItemIds
     * @param {string[]} itemIds - Item id's of results to fetch
     * @param {object} [parameters] - Additional parameters to refine result set
     * @param {number} [parameters.page] - The page number of the results (Can't be used together with offset)
     * @param {number} [parameters.offset] - The number of results to skip from the beginning (Can't be used together with page)
     * @param {number} [parameters.resultsPerPage] - The number of results per page to return
     * @param {object} [parameters.filters] - Filters used to refine results
     * @param {string} [parameters.sortBy='relevance'] - The sort method for results
     * @param {string} [parameters.sortOrder='descending'] - The sort order for results
     * @param {string} [parameters.section='Products'] - The section name for results
     * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.io/rest_api/browse/queries/ for details
     * @param {string[]} [parameters.hiddenFields] - Hidden metadata fields to return
     * @param {string[]} [parameters.hiddenFacets] - Hidden facets to return
     * @param {object} [parameters.variationsMap] - The variations map object to aggregate variations. Please refer to https://docs.constructor.io/rest_api/variations_mapping for details
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {Promise}
     * @see https://docs.constructor.io/rest_api/browse/items/
     * @example
     * constructorio.browse.getBrowseResultsForItemIds(['shirt-123', 'shirt-456', 'shirt-789'], {
     *     filters: {
     *         size: 'medium'
     *     },
     * });
     */

  }, {
    key: "getBrowseResultsForItemIds",
    value: function getBrowseResultsForItemIds(itemIds, parameters) {
      var _this2 = this;

      var networkParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var requestUrl;
      var fetch = this.options && this.options.fetch || fetchPonyfill({
        Promise: Promise
      }).fetch;
      var signal;

      if (typeof AbortController === 'function') {
        var controller = new AbortController();
        signal = controller && controller.signal; // Handle network timeout if specified

        helpers.applyNetworkTimeout(this.options, networkParameters, controller);
      }

      try {
        requestUrl = createBrowseUrlFromIDs(itemIds, parameters, this.options);
      } catch (e) {
        return Promise.reject(e);
      }

      return fetch(requestUrl, {
        signal: signal
      }).then(function (response) {
        if (response.ok) {
          return response.json();
        }

        return helpers.throwHttpErrorFromResponse(new Error(), response);
      }).then(function (json) {
        if (json.response && json.response.results) {
          if (json.result_id) {
            // Append `result_id` to each result item
            json.response.results.forEach(function (result) {
              // eslint-disable-next-line no-param-reassign
              result.result_id = json.result_id;
            });
          }

          _this2.eventDispatcher.queue('browse.getBrowseResultsForItemIds.completed', json);

          return json;
        }

        throw new Error('getBrowseResultsForItemIds response data is malformed');
      });
    }
    /**
     * Retrieve browse groups from API
     *
     * @function getBrowseGroups
     * @param {object} [parameters.filters] - Filters used to refine results
     * @param {string} [parameters.section='Products'] - The section name for results
     * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.io/rest_api/browse/groups/ for details
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {Promise}
     * @see https://docs.constructor.io/rest_api/browse/groups
     * @example
     * constructorio.browse.getBrowseGroups({
     *     filters: {
     *         group_id: 'drill_collection'
     *     },
     *     fmtOptions: {
     *         groups_max_depth: 2
     *     }
     * });
     */

  }, {
    key: "getBrowseGroups",
    value: function getBrowseGroups(parameters) {
      var _this3 = this;

      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetch = this.options && this.options.fetch || fetchPonyfill({
        Promise: Promise
      }).fetch;
      var serviceUrl = this.options.serviceUrl;
      var queryParams = createQueryParams(parameters, this.options);
      var signal;

      if (typeof AbortController === 'function') {
        var controller = new AbortController();
        signal = controller && controller.signal; // Handle network timeout if specified

        helpers.applyNetworkTimeout(this.options, networkParameters, controller);
      }

      delete queryParams._dt;
      var queryString = qs.stringify(queryParams, {
        indices: false
      });
      var requestUrl = "".concat(serviceUrl, "/browse/groups?").concat(queryString);
      return fetch(requestUrl, {
        signal: signal
      }).then(function (response) {
        if (response.ok) {
          return response.json();
        }

        return helpers.throwHttpErrorFromResponse(new Error(), response);
      }).then(function (json) {
        if (json.response && json.response.groups) {
          _this3.eventDispatcher.queue('browse.getBrowseGroups.completed', json);

          return json;
        }

        throw new Error('getBrowseGroups response data is malformed');
      });
    }
    /**
     * Retrieve browse facets from API
     *
     * @function getBrowseFacets
     * @param {object} [parameters] - Additional parameters to refine result set
     * @param {number} [parameters.page] - The page number of the results (Can't be used together with offset)
     * @param {number} [parameters.offset] - The number of results to skip from the beginning (Can't be used together with page)
     * @param {string} [parameters.section='Products'] - The section name for results
     * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.io/rest_api/browse/facets/ for details
     * @param {number} [parameters.resultsPerPage] - The number of results per page to return
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {Promise}
     * @see https://docs.constructor.io/rest_api/browse/facets
     * @example
     * constructorio.browse.getBrowseFacets({
     *     page: 1,
     *     resultsPerPage: 10,
     * });
     */

  }, {
    key: "getBrowseFacets",
    value: function getBrowseFacets(parameters, networkParameters) {
      var _this4 = this;

      var requestUrl;
      var fetch = this.options && this.options.fetch || fetchPonyfill({
        Promise: Promise
      }).fetch;
      var signal;

      if (typeof AbortController === 'function') {
        var controller = new AbortController();
        signal = controller && controller.signal; // Handle network timeout if specified

        helpers.applyNetworkTimeout(this.options, networkParameters, controller);
      }

      try {
        requestUrl = createBrowseUrlForFacets(parameters, this.options);
      } catch (e) {
        return Promise.reject(e);
      }

      return fetch(requestUrl, {
        signal: signal
      }).then(function (response) {
        if (response.ok) {
          return response.json();
        }

        return helpers.throwHttpErrorFromResponse(new Error(), response);
      }).then(function (json) {
        if (json.response && json.response.facets) {
          _this4.eventDispatcher.queue('browse.getBrowseFacets.completed', json);

          return json;
        }

        throw new Error('getBrowseFacets response data is malformed');
      });
    }
    /**
     * Retrieve facet options from API
     *
     * @function getBrowseFacetOptions
     * @param {string} facetName - Name of the facet whose options to return
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @param {object} [parameters] - Additional parameters to refine result set
     * @param {string} [parameters.section='Products'] - The section name for results
     * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.io/rest_api/browse/facet_options/ for details
     * @param {}
     * @returns {Promise}
     * @see https://docs.constructor.io/rest_api/browse/facet_options/
     * @example
     * constructorio.browse.getBrowseFacetOptions('price', {
     * });
     */

  }, {
    key: "getBrowseFacetOptions",
    value: function getBrowseFacetOptions(facetName) {
      var _this5 = this;

      var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var networkParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var requestUrl;
      var fetch = this.options && this.options.fetch || fetchPonyfill({
        Promise: Promise
      }).fetch;
      var signal;

      if (typeof AbortController === 'function') {
        var controller = new AbortController();
        signal = controller && controller.signal; // Handle network timeout if specified

        helpers.applyNetworkTimeout(this.options, networkParameters, controller);
      }

      try {
        requestUrl = createBrowseUrlForFacetOptions(facetName, parameters, this.options);
      } catch (e) {
        return Promise.reject(e);
      }

      return fetch(requestUrl, {
        signal: signal
      }).then(function (response) {
        if (response.ok) {
          return response.json();
        }

        return helpers.throwHttpErrorFromResponse(new Error(), response);
      }).then(function (json) {
        if (json.response && json.response.facets) {
          _this5.eventDispatcher.queue('browse.getBrowseFacetOptions.completed', json);

          return json;
        }

        throw new Error('getBrowseFacetOptions response data is malformed');
      });
    }
  }]);
  return Browse;
}();

module.exports = Browse;